<script lang="ts">
  // EIN Zahnrad je Bereich, im Kopf seines Baums (Tim 01.11.2026: „Ein
  // Zahnrad reicht pro Bereich. Dort wird dann auf alle relevanten
  // Einstellungen gefiltert. An jede Einstellung ein Zahnrad wäre zu
  // viel"). Öffnet /einstellungen?bereich=<id>: das Fenster zeigt nur die
  // Einträge, deren Seite in diesem Bereich liegt (manifest.ts imBereich).
  // Ohne solche Einträge steht es nicht da.
  import SymbolKnopf from "./SymbolKnopf.svelte";
  import { EINSTELLUNGEN, imBereich } from "./einstellungen/manifest";
  import { t } from "./i18n.svelte";
  import { navSections, type SectionId } from "./nav-sections";
  import { navigate } from "./router.svelte";

  let { bereich }: { bereich: SectionId } = $props();

  const sec = $derived(navSections.find((s) => s.id === bereich));
  const da = $derived(!!sec && EINSTELLUNGEN.some((e) => imBereich(e, sec.prefixes)));
</script>

{#if da && sec}
  <SymbolKnopf
    icon="settings"
    klein
    label={t("einstellung.zahnrad", "Einstellungen · {bereich}").replace("{bereich}", sec.label)}
    onclick={() => navigate(`/einstellungen?bereich=${encodeURIComponent(bereich)}`)}
  />
{/if}
